import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';


const SalesMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false);
  const [prdmodalVisible, setPrdModalVisible] = useState(false);  
  const [addPrdmodalVisible, setAddPrdModalVisible] = useState(false);      

  const [accList, setAccList] = useState([]);
  const [accSelected, setAccSelected] = useState('');

  const [sales, setSales] = useState([]);
  const [selectedSales, setSelectedSales] = useState([]);
  
  const [selectedSalesDetail, setSelectedSalesDetail] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [productUnits, setProductUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('');
  const [delBoyList, setDelBoyList] = useState([]);
  const [areasList, setAreasList] = useState([]);
  
  const [areas, setAreas] = useState([]);
  
  const [catList, setCatList] = useState([]);
  const [selectedCatList, setSelectedCatList] = useState('');
  const [productList, setProductList] = useState([]);
  const [selectedAddProductId, setSelectedAddProductId] = useState('');
  const [selectedAddProductQty, setSelectedAddProductQty] = useState('');
  const [selectedAddProductUnit, setSelectedAddProductUnit] = useState('');
  const [selectedAddProductRate, setSelectedAddProductRate] = useState('');
  const [selectedAddProductAmt, setSelectedAddProductAmt] = useState('');
   
  const [mobileNumber, setMobileNumber] = useState('');
  const [custDetail, setCustDetail] = useState(''); 
  const [payType, setPayType] = useState('Cash'); 
  const [cashAccList, setCashAccList] = useState([]);
  const [cashSelectAcc, setCashSelectAcc] = useState(''); 

  const today = new Date().toISOString().split("T")[0];
  const [entryDate, setEntryDate] = useState(today);

  const handleBack = () => {
    navigate('../dashboard');
  };

  const fetchSalesList = async () => { 
          try {
            const response = await fetch(`${host_url}/sales_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
                'userid': localStorage.getItem('userid'),
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                sdate: startDate,
                edate: endDate,
              }),
            });

            if (response.status === 401) {
              localStorage.clear();
              alert('Your account has been disabled.');
              window.location.href = "/";
              return;
            }
      
            const data = await response.json();
            setSales(data);
            console.log(data);

            const uniqueDeliveryBoys = Object.values(
              data.reduce((acc, item) => {
                acc[item.sl_del_id] = {
                  id: item.sl_del_id,
                  name: item.sl_del_name
                };
                return acc;
              }, {})
            );
            setDelBoyList(uniqueDeliveryBoys);
            console.log(uniqueDeliveryBoys);

            const uniqueAreas = Object.values(
              data.reduce((acc, item) => {
                acc[item.sl_area_id] = {
                  areaId: item.sl_area_id,
                  areaName: item.sl_area_name
                };
                return acc;
              }, {})
            );
            setAreasList(uniqueAreas);
            console.log(uniqueAreas);

          } catch (error) {
            console.error('Error fetching cities:', error);
          }
      }; 

    useEffect(() => {
      document.title = "Sales Master";
    }, []); // for Title Set  

   // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            if (prdmodalVisible || addPrdmodalVisible) {
              setPrdModalVisible(false);
              setAddPrdModalVisible(false);
            } else {
              setModalVisible(false);
              setAddModalVisible(false);
            }
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert") {
          if (modalVisible) {
            setSelectedAddProductId('');
            setSelectedAddProductQty('');
            setSelectedAddProductAmt('');
            setAddPrdModalVisible(true);
          } else {
            if(addmodalVisible) {
              setAddPrdModalVisible(true);
            } else {
              setAddModalVisible(true);
            }
          }
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, prdmodalVisible, addPrdmodalVisible]);

    useEffect(() => {   
     fetchSalesList(); 
    }, [host_url, selectedSalesDetail]); // Sales List
     
    useEffect(() => { 
      const fetchAreaList = async () => {       
          try {
            const response = await fetch(`${host_url}/area_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                areaId : '',
                areaName: '',
                areaEName: '',
              }),
            });
            const data = await response.json();
            setAreas(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAreaList(); 
    }, [host_url]);  // Area List

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          try {
            const response = await fetch(`${host_url}/category`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
              }),
            });
            
            const data = await response.json();
            setCatList(data);
            setSelectedCatList(data[0].pcat_id)
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url, store]);  // Category List

    
    useEffect(() => { 
      
        const accountDetail = {
            acc_type: 'CashBank_Party',
        };
        const fetchAccountDetail = async () => { 
          try {
            const response = await fetch(`${host_url}/account_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: accountDetail,
              }),
            });            
            const data = await response.json();
            setCashAccList(data);              
           
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
       fetchAccountDetail();  
    }, [addmodalVisible]); // Cash Bank Account List

    useEffect(() => { 
      const fetchProductList = async () => { 
          try {
            const response = await fetch(`${host_url}/product_admin`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
                pcatId: selectedCatList,
              }),
            });            
            const data = await response.json();
            if(data.length > 0 ) {
              data.sort((a, b) => a.prd_name.trim().localeCompare(b.prd_name.trim(), 'gu'));
              setProductList(data);
              setSelectedAddProductId(data[0].prd_id);
            }
            
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
       
      }; 
     fetchProductList(); 
    }, [selectedCatList]);  // Product List

    useEffect(() => { 
      if (mobileNumber.length == 10 && /^[0-9]*$/.test(mobileNumber)){
        const fetchCustDetail = async () => { 
          try {
            const response = await fetch(`${host_url}/cust_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
                custMo: mobileNumber,
              }),
            });            
            const data = await response.json();
            if(data.error) {
              alert(data.error);
            } else {
              setCustDetail(data[0]);  
                  if(mobileNumber == '9999999999') {
                    setPayType('Cash') 
                  } else {
                    setPayType('Debit') ; 
                  }             
            }
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
       fetchCustDetail();  
      } 

      if (mobileNumber.length < 10) {
        setCustDetail('');
      }
    }, [mobileNumber]); // Customer Detail

    useEffect(() => {
      const fetchProductList = async () => {
        if(selectedAddProductId){
          const productSelect = productList.find(product => product.prd_id == selectedAddProductId);
          setSelectedAddProductAmt(Math.round(productSelect.prd_rate * selectedAddProductQty));
        }
      };

      fetchProductList();
    }, [selectedAddProductId, selectedAddProductQty]);  // Product Rate Sort


    const sdate = new Date();
    sdate.setMonth(sdate.getMonth());
    sdate.setDate(1);
    const ThreeMonthAgo = sdate.toISOString().split("T")[0];

    const edate = new Date();
    edate.setMonth(edate.getMonth());
    edate.setDate(edate.getDate());
    const currentDate = edate.toISOString().split("T")[0];
    
    const [startDate, setStartDate] = useState(ThreeMonthAgo);
    const [endDate, setEndDate] = useState(currentDate);
    const [custNameFilter, setCustNameFilter] = useState('');
    const [custIdFilter, setCustIdFilter] = useState('');
    const [areaIdFilter, setAreaIdFilter] = useState('');
    const [delIdFilter, setDelIdFilter] = useState('');
    

    const filteredPurchase = sales.filter(sale =>{

      const salesDate = new Date(sale.sl_date).toLocaleDateString('en-CA');
      
      return (
        String(sale.sl_cust_id).toLowerCase().includes(custIdFilter.toLowerCase()) &&
        sale.sl_cust_name.toLowerCase().includes(custNameFilter.toLowerCase()) &&
        String(sale.sl_area_id).toLowerCase().includes(areaIdFilter.toLowerCase()) &&
        String(sale.sl_del_id).toLowerCase().includes(String(delIdFilter).toLowerCase()) &&
        (!startDate || salesDate >= startDate) && 
        (!endDate || salesDate <= endDate)
      );
    });

    const totalCount = filteredPurchase.length;
    const totalSalesAmt = filteredPurchase.reduce((sum, pur) => sum + Number(pur.sl_sales_amt), 0);

    const detailtotalWeight = selectedSalesDetail.reduce((sum, product) => sum + Number(product.sd_prd_qty), 0);
    const detailtotalAmt = selectedSalesDetail.reduce((sum, product) => sum + Number(product.sd_prd_amt), 0);

    const handleSalesDetail = async (sale) => {
      setModalVisible(true);
      setSelectedSales(sale);
      setSelectedSalesDetail([]);
      const salesDetail = {
            sl_id: sale.sl_id,
        };
      try {
        const response = await fetch(`${host_url}/sales_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store, 
            salesdetail: salesDetail,  
          }),
        });
        const data = await response.json();
        setSelectedSalesDetail(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }  
    };

    const hamdlePSalesAddModal = () => {
      setAddModalVisible(true);
      setSelectedSalesDetail([]);
      setAccSelected('');
    };

    const handleSalesSubmit = async () => {
      console.log("selectedSalesDetail", selectedSalesDetail);
      console.log("Customer", custDetail);
      setAddModalVisible(false);
      const cash_acc_id = payType === 'Cash' ? cashSelectAcc : 0;
      console.log("cash_acc_id", cash_acc_id);
      
      
      try {
        const response = await fetch(`${host_url}/sales_admin`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store, 
            del_id: '110',
            order_no : entryDate,
            cash_receipt: payType === 'Cash' ? detailtotalAmt : 0,
            cash_acc_id: payType === 'Cash' ? cashSelectAcc : 0,
            ord_amt: detailtotalAmt,
            custId: custDetail.custId,
            cust_name: custDetail.custEName,
            delivery_items : selectedSalesDetail,
          }),
        });
        const data = await response.json();
        setSales(data);
        setSelectedSalesDetail([]);
               
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
      fetchSalesList(); 
    };

    const handleProductAdd = async () => {
      if (selectedAddProductId) {
        const purAddDetail = {
            sl_id: selectedSalesDetail[0].sd_sl_id,
            prd_id: selectedAddProductId,
            prd_qty: selectedAddProductQty,
            prd_unit: `${selectedAddProductQty} ${selectedAddProductUnit}`,
            prd_amt: selectedAddProductAmt,
        };

        try {
          const response = await fetch(`${host_url}/sales_select`, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              type: 'Add_Product', 
              store: store, 
              purdetail: purAddDetail,
            }),
          });
          const data = await response.json();
          setSelectedSalesDetail(data);
          console.log(data);
          setProductUnits([]);
          setSelectedUnit('');
          setSelectedAddProductId('');
          setAddPrdModalVisible(false);
        } catch (error) {
          console.error('Error fetching cities:', error);
        }

        
      } else {
        alert('Please Selct Product And Units');
        
      }
    };

    const handleProductUpdate = async () => {
      setPrdModalVisible(false); 
      const purupdateDetail = {
            pd_id: selectedProduct.pd_id,
            sl_id: selectedSalesDetail[0].sd_sl_id,
            prd_id: selectedProduct.pd_prd_id,
            prd_qty: selectedProduct.pd_prd_qty,
            prd_amt: selectedProduct.pd_prd_amt,
        };


      try {
        const response = await fetch(`${host_url}/purchase_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'Update_Product', 
            store: store, 
            purdetail: purupdateDetail, 
          }),
        });
        const data = await response.json();
        setSelectedSalesDetail(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    
    const handleProductDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this product?');
        if (userConfirmed) {
          const purdeleteDetail = {
            pd_id: selectedProduct.pd_id,
            sl_id: selectedSalesDetail[0].sd_sl_id,
            pd_prd_id: selectedProduct.pd_prd_id,
            pd_prd_qty: selectedProduct.pd_prd_qty,
            pd_prd_amt: selectedProduct.pd_prd_amt,
        };
          console.log(purdeleteDetail);
          
          try {
            const response = await fetch(`${host_url}/purchase_select`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'Delete_Product', 
                store: store, 
                purdetail: purdeleteDetail,
              }),
            });
            const data = await response.json();
            setSelectedSalesDetail(data);
            setPrdModalVisible(false);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
        }
    };

    const handleProductAddInNewOrder = async () => {
      let unit = '';
      if (selectedAddProductId) {
        const prd_name = productList.find(product => product.prd_id == selectedAddProductId)?.prd_name;
        if(selectedAddProductUnit === 'g'){
            unit = `${selectedAddProductQty * 1000} ${selectedAddProductUnit}`
        } else if(selectedAddProductUnit === 'kg'){
            unit = `${Number(selectedAddProductQty).toFixed(3)} ${selectedAddProductUnit}`
        } else {
            unit = `${selectedAddProductQty} ${selectedAddProductUnit}`
        }
        const purAddDetail = {
            sl_id: 0,
            prd_name: prd_name,
            sd_prd_id: selectedAddProductId,
            sd_prd_qty: selectedAddProductQty || 0,

            sd_prd_unit: unit || '',
            sd_prd_amt: selectedAddProductAmt || 0,
        };

        setSelectedSalesDetail(prevDetails => [...prevDetails, purAddDetail]);
        setSelectedAddProductId('');
        setSelectedAddProductQty('');
        setSelectedAddProductAmt('');
                 
      } else {
        alert('Please Selct Product');
        
      }
    };


  
  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Sales Master</b>
                <div onClick={hamdlePSalesAddModal}>
                  <img src={insertlogo} alt="Back" className='system-icon'/>
                </div>
          </div>
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >        
                <th ><input type="date" className="search-input  no-icon" style={{ textAlign: 'center' }} value={startDate} onChange={(e) => setStartDate(e.target.value)} onBlur={fetchSalesList} /></th>
                <th >Cust Id</th>
                <th colSpan='2'>Name</th>
                <th >Area</th>
                <th >Rider</th>
                <th>Amount</th>
              </tr>
              <tr>
                <th ><input type="date" className="search-input  no-icon" style={{ textAlign: 'center' }} value={endDate} onChange={(e) => setEndDate(e.target.value)} onBlur={fetchSalesList} /></th>
                <th >
                  <input
                    type="text"
                    className="search-input"
                    value={custIdFilter}
                    onChange={(e) => setCustIdFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custNameFilter}
                    onChange={(e) => setCustNameFilter(e.target.value)}
                  />
                </th>
                <th >
                  <select
                    className="search-input"
                    value={areaIdFilter}
                    onChange={(e) => setAreaIdFilter(e.target.value)}
                  >
                    <option value="">All Area</option>
                    {areasList.map((area) => (
                        <option key={area.areaId} value={area.areaId}>
                          {area.areaName}
                        </option>
                    ))}
                  </select>
                </th>
                <th >
                  <select
                    className="search-input"
                    value={delIdFilter}
                    onChange={(e) => setDelIdFilter(e.target.value)}
                  >
                    <option value="">All Person</option>
                    {delBoyList.map((delboy) => (
                        <option key={delboy.id} value={delboy.id}>
                          {delboy.name}
                        </option>
                    ))}
                  </select>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredPurchase.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px' }} onClick={() => handleSalesDetail(row)}>
                      <td > {new Date(row.sl_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                      <td  className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.sl_cust_id}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.sl_cust_name}</span></td>
                      <td  className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.sl_area_name}</span></td>
                      <td  className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.sl_del_name}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.sl_sales_amt}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" ><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-left" ><span style={{ paddingLeft: '10px' }}>Avg : {totalCount > 0 ? (totalSalesAmt / totalCount).toFixed(0) : 0}</span></th>
                <th colSpan='4' className="cell-left" ><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-right" ><span style={{ paddingRight: '15px' }}>{totalSalesAmt}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Sales Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h6>{selectedSales.sl_cust_name} - {new Date(selectedSales.sl_date).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false,}).replace(/\//g, "-")}</h6>                
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedSalesDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} >
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_qty}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody> 
                      <tfoot>
                        {(selectedSales.sl_sales_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0)) < 0) && (
                          <tr>
                            <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Round off</td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} ></td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{selectedSales.sl_sales_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0))}</td>
                          </tr>
                        )}
                        <tr>
                          <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >Total</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalWeight.toFixed(3)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{selectedSales.sl_sales_amt}</th>
                        </tr> 
                      </tfoot>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '30%', margin: '0 auto' }}>
                      <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
              </ModalBody>
            </Modal>

          {/* Modal for Add New Sales  */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: '0 auto' }}>
                    <span>
                        <input
                          type="text"
                          id="mobileNumber"
                          value={mobileNumber}
                          onChange={(e) => setMobileNumber(e.target.value)}
                          placeholder="Registered Mobile Number"
                          maxLength="10"  
                        />
                    </span>
                    <span>
                        {custDetail.custId} - {custDetail.custEName}
                    </span>
                    <span> 
                          <select
                            value={payType}
                            onChange={(e) => setPayType(e.target.value)}
                          >
                            <option value="Cash">Cash</option>
                            <option value="Debit">Debit</option>
                          </select>
                    </span> 

                    {payType === 'Cash' && (
                      <span>
                        <select
                          value={cashSelectAcc}
                          onChange={(e) => setCashSelectAcc(e.target.value)}
                        >
                          {cashAccList.map((cashAccList, index) => (
                            <option key={index} value={cashAccList.sacc_id}>
                              {cashAccList.sacc_name}
                            </option>
                          ))}
                        </select>
                      </span>
                    )}
                    <span> 
                      <input type="date" className='no-icon'  value={entryDate} onChange={(e) => setEntryDate(e.target.value)} />
                    </span> 
                </div> 
                <div>
                  <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >Item</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Rate</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                      </tr>
                    </thead>
                    <tbody className="scrollable-body">
                      {selectedSalesDetail.map((row) => {
                          return (
                            <tr key={row.prd_id} style={{ cursor: 'pointer' }} >
                              <td colSpan='2' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                              <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_unit}</td>
                              <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{(row.sd_prd_amt/row.sd_prd_qty).toFixed(2)}</td>
                              <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_amt}</td>
                            </tr>
                          );
                      })}
                    </tbody> 
                    <tfoot>
                      <tr>
                        <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >Total</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalWeight.toFixed(3)}</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} ></th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt}</th>
                      </tr> 
                    </tfoot>
                  </table>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', margin: '0 auto' }}>
                    <Button color="info" style={{ flex: 1, marginLeft: '10px'}} onClick={() => setAddPrdModalVisible(true)} >
                      Add New 
                    </Button>
                     <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px'}} onClick={handleSalesSubmit}  disabled={!mobileNumber || !entryDate || selectedSalesDetail.length < 1}>
                      Submit Entry 
                    </Button>
                    <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                </div>
                
              </ModalBody>
            </Modal>
         
          {/* Modal for Product Detail */}
            <Modal isOpen={prdmodalVisible} toggle={() => setModalVisible(!prdmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}> 
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>Catagory</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedCatList}
                                onChange={(e) => setSelectedCatList(e.target.value)}
                              >
                                {catList.map((catList, index) => (
                                    <option key={index} value={catList.pcat_id}>
                                      {catList.pcat_name}
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Product</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedProduct.pd_prd_id}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, pd_prd_id: e.target.value })}
                              >
                                <option key='' value=''>Select Product</option>
                                {productList.map((plist, index) => (
                                    <option key={index} value={plist.prd_id}>
                                      {plist.prd_name} 
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.pd_prd_qty}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, pd_prd_qty: e.target.value })}
                            />
                          </td>  
                        </tr>
                        <tr>
                          <td>Amount</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.pd_prd_amt}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, pd_prd_amt: e.target.value })}
                            />
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductDelete} disabled={selectedSalesDetail.length < 2 }>
                      Delete Product
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductUpdate} >
                      Update Product
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setPrdModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        

          {/* Modal for Add Product Detail */}
            <Modal isOpen={addPrdmodalVisible} toggle={() => setModalVisible(!addPrdmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>Catagory</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedCatList}
                                onChange={(e) => setSelectedCatList(e.target.value)}
                              >
                                {catList.map((catList, index) => (
                                    <option key={index} value={catList.pcat_id}>
                                      {catList.pcat_name}
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Product</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                onChange={(e) => setSelectedAddProductId(e.target.value)}
                              >
                                <option key='' value=''>Select Product</option>
                                {productList.map((plist, index) => (
                                    <option key={index} value={plist.prd_id}>
                                      {plist.prd_name} 
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedAddProductQty}
                              onChange={(e) => setSelectedAddProductQty(e.target.value)}
                            />
                          </td>  
                        </tr>
                        <tr>
                          <td>Unit</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                onChange={(e) => setSelectedAddProductUnit(e.target.value)}
                              >
                                <option key='' value=''>Select Product</option>
                                <option key='1' value="kg">Kg</option>
                                <option key='2' value="g">Gram</option>
                                <option key='3' value="Bundle">Bundle</option>
                                <option key='4' value="Pcs">Piece</option>
                                <option key='5' value="Pack">Packet</option>
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Amount</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedAddProductAmt}
                              onChange={(e) => setSelectedAddProductAmt(e.target.value)}
                            />
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={modalVisible ? handleProductAdd : handleProductAddInNewOrder} 
                          disabled={ !selectedAddProductId || !selectedAddProductQty || !selectedAddProductUnit || !selectedAddProductAmt}>
                      Add Product
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddPrdModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>          
         
    </div>
  );
};

export default SalesMaster;
